import { Sites } from '@ps/platform-message-framework/common/Sites';

import type { StakeError } from '../types';

import {
  TXTWCL_Maximum_stake_is_N0,
  TXTWCL_Minimum_stake_is_N0,
  TXTWCL_Minimum_stake_per_leg_is_N0,
  TXTWCL_Stake_must_be_a_multiple_of_N0,
  TXTWCL_Your_potential_payout_exceeds__ELL_1
} from './validateStake.messages.json';

export interface MinMaxStakeOptions {
  minStake: number;
  maxStake: number;
  minLineStake?: number;
  minStakeIncrement: number;
  maxPayout?: number;
  numberOfLines: number;
  stake: number;
  site: Sites;
  isWinPotentialReturnAboveMaxPayout: boolean;
}

const getIsInvalidStakeIncrement = (minStakeIncrement: number, stake: number): boolean => {
  if (minStakeIncrement === 0.01) {
    return false;
  }

  const stakeInteger = stake * 100;
  const minStakeIncrementInteger = minStakeIncrement * 100;

  return Boolean(Math.round(stakeInteger) % Math.round(minStakeIncrementInteger));
};

const validateStake = ({
  minStake,
  maxStake,
  minLineStake,
  minStakeIncrement,
  maxPayout,
  numberOfLines,
  stake,
  site,
  isWinPotentialReturnAboveMaxPayout
}: MinMaxStakeOptions): StakeError | undefined => {
  if (stake === 0) {
    return;
  }

  const hasItalianRegulations = !!minLineStake && site === Sites.ITA;

  // Priority order 1
  if (!hasItalianRegulations && stake < minStake) {
    return {
      value: minStake,
      translationTag: TXTWCL_Minimum_stake_is_N0,
      actionableValue: true
    };
  }

  if (hasItalianRegulations) {
    // Priority order 2
    if (stake * numberOfLines < minStake) {
      return {
        value: minStake,
        translationTag: TXTWCL_Minimum_stake_is_N0,
        actionableValue: false
      };
    }

    // Priority order 3
    if (stake < minLineStake) {
      return {
        value: minLineStake,
        translationTag: TXTWCL_Minimum_stake_per_leg_is_N0,
        actionableValue: true
      };
    }
  }

  // Priority order 4/5
  if (site === Sites.ITA && getIsInvalidStakeIncrement(minStakeIncrement, stake)) {
    return {
      value: minStakeIncrement,
      translationTag: TXTWCL_Stake_must_be_a_multiple_of_N0,
      actionableValue: false
    };
  }

  // Priority order 6
  if (stake > maxStake) {
    return {
      value: maxStake,
      translationTag: TXTWCL_Maximum_stake_is_N0,
      actionableValue: true
    };
  }

  // Priority order 7
  if (maxPayout && isWinPotentialReturnAboveMaxPayout) {
    return {
      value: maxPayout,
      translationTag: TXTWCL_Your_potential_payout_exceeds__ELL_1,
      actionableValue: false
    };
  }
};

export default validateStake;
